import React from 'react';
import { ProcessType } from '../../../../Services/WorkflowServicesTypes';
import ImpersonatingServices from '../../../../Services/ImpersonatingServices';
import ProcessStatusProvider from './context/ProcessStatusContext';
import ProcessStatusButton from './ProcessStatusButton';
import ProcessRequestConfirmation from './ProcessRequestConfirmation';
import ProcessRequestsDetails from './ProcessRequestsDetails';

type ProcessStatusWidgetType = { processType: ProcessType, $http: any, $rootScope: any, $routeParams: any, $timeout: any };

const ProcessStatusWidget = ({ processType, $http, $rootScope, $routeParams, $timeout }: ProcessStatusWidgetType) => {

	const impersonatingServices = new ImpersonatingServices($rootScope, $routeParams);
	const impersonatedAccount = impersonatingServices.getImpersonatedAccount();
	const accountId = impersonatedAccount || $rootScope.User.Account.Key;

	return (
		<ProcessStatusProvider processType={processType} accountId={accountId}
			$http={$http} $rootScope={$rootScope} $timeout={$timeout}>

			<ProcessStatusButton />
			<ProcessRequestConfirmation />
			<ProcessRequestsDetails />

		</ProcessStatusProvider>
	);
};

export default ProcessStatusWidget;